import { useCallback } from 'react';

import NotificationAPI from '@trend-dev/trendtech-ui/components/UI/Notifications/api';
import { copyToClipboard } from '@trend-dev/ui-libs-utils/utils/copyToClipboard';

import { useControlStore } from 'store/controls';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { getDevicePermission } from 'utils/getDevicePermission';

import { useCameraContext } from '../CameraPermissionContext';
import type { Control } from '../constants/controls';

const notificationContent = 'Ссылка скопирована';

export function useControlActions() {
    const { handleCameraClick, handleMicrophoneClick, handleScreenShareClick, showLeaveModal } = useControlStore();
    const { setGrantedState, setTutorialState, triggerYMCamera } = useCameraContext();
    const { triggerYM } = useYM();

    return useCallback(
        (type: Control['type']) => {
            return () => {
                if (type === 'mic') {
                    handleMicrophoneClick();
                    triggerYM({ goal: GoalType.CONFERENCE_PAGE_MIC });
                }

                if (type === 'cam') {
                    triggerYM({ goal: GoalType.CONFERENCE_PAGE_CAM });
                    getDevicePermission({ video: true })
                        .then(() => {
                            triggerYMCamera(GoalType.CONFERENCE_PAGE_CAM_PERMISSION_SUCCESS);
                            setGrantedState(true);
                            setTutorialState(false);
                            handleCameraClick();
                        })
                        .catch(() => {
                            triggerYMCamera(GoalType.CONFERENCE_PAGE_CAM_PERMISSION);
                            setGrantedState(false);
                            setTutorialState(true);
                        });
                }

                if (type === 'screen') {
                    handleScreenShareClick();
                }

                if (type === 'invite') {
                    copyToClipboard(window.location.href);
                    NotificationAPI.open({
                        message: notificationContent,
                        options: { closeBtn: false, kind: 'success', mini: true, paperProps: { border: true, size: 'sm' } },
                    });
                    triggerYM({ goal: GoalType.CONFERENCE_PAGE_INVITE });
                }
                if (type === 'leave') {
                    showLeaveModal();
                }
            };
        },
        [handleScreenShareClick, handleMicrophoneClick, handleCameraClick, showLeaveModal],
    );
}
